import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { UserAuditHistoryFilters } from '../intefaces/user-audit-history-filters.interface';
import { UserAuditHistoryPreparedData } from '../intefaces/user-audit-history-prepared-data.interface';
import { UserAuditHistory } from '../intefaces/user-audit-history.interface';

@Injectable({
    providedIn: 'root'
})
export class AuditHistoryService {

    userFilters: UserAuditHistoryFilters[];

    constructor(private translate: TranslateService) {
        this.userFilters = [
            { code: 0, translate_key: 'change_email_by_user' },
            { code: 1, translate_key: 'change_password_by_user' },
            { code: 2, translate_key: 'change_user_details_by_user' },
            { code: 3, translate_key: 'block_account_by_admin' },
            { code: 4, translate_key: 'unblock_account_by_admin' },
            { code: 5, translate_key: 'block_selling_notes' },
            { code: 6, translate_key: 'change_access_level' },
            { code: 7, translate_key: 'update_user_details_by_admin' },
            { code: 8, translate_key: 'update_arranger_details_by_admin' },
            { code: 9, translate_key: 'update_arranger_commission_by_admin' },
            { code: 10, translate_key: 'update_arranger_short_desc_by_admin' },
            { code: 11, translate_key: 'update_arranger_full_desc_by_admin' },
            { code: 12, translate_key: 'update_arranger_short_desc_by_user' },
            { code: 13, translate_key: 'update_arranger_full_desc_by_user' },
            { code: 14, translate_key: 'update_arranger_details_by_user' },
            { code: 15, translate_key: 'account_created' },
        ]
    }

    public getFilters(): UserAuditHistoryFilters[] {
        return this.userFilters;
    }

    public prepareData(data: UserAuditHistory[]): Promise<UserAuditHistoryPreparedData[]> {
        return new Promise<UserAuditHistoryPreparedData[]>((resolve, reject) => {
            let preparedData: UserAuditHistoryPreparedData[] = [];
            data.forEach((obj: UserAuditHistory) => {
                preparedData.push({
                    date: obj.created_at,
                    desc: this.prepareUserAuditHistoryLine(Number(obj.code), obj.action, obj.data, obj.admin_id)
                });
            });
            resolve(preparedData);
        });
    }

    private prepareUserAuditHistoryLine(c: number, d: string, n: string, a: number): string {
        let row = '';
        let _n: any;
        n = n == null ? '' : n;
        n.replace('null', '');
        n.replace(null, '');
        switch (c) {
            case 0: // Change email by user
                row = this.translate.instant(d) + '. ' + n;
                break;
            case 1: // Change password by user
                row = this.translate.instant(d)
                break;
            case 2: // Change user details by user
                _n = this.convertToObject(n);
                row = this.translate.instant(d) + '. ' + _n.name + ', ' + _n.surname + ', ' + _n.phone;
                break;
            case 3: // Block by admin
                row = this.translate.instant(d) + ' ID: ' + a;
                break;
            case 4: // Unblock by admin
                row = this.translate.instant(d) + ' ID: ' + a;
                break;
            case 5: // Block selling notes
                row = this.translate.instant(d) + ' ID: ' + a;
                break;
            case 6: // Change access level
                row = this.translate.instant(d) + ' ID: ' + a;
                break;
            case 7: // Update user details by admin
                _n = this.convertToObject(n);
                row = this.translate.instant(d) + ' ID: ' + a + '. ' + _n.name + ', ' + _n.surname + ', ' + _n.phone;
                break;
            case 8: // Update arranger details by admin
                _n = this.convertToObject(n);
                row = this.translate.instant(d) + ' ID: ' + a + '. ' +
                    _n.pesel + ', ' +
                    _n.tax_number + ', ' +
                    _n.country + ', ' +
                    _n.city + ', ' +
                    _n.street + ', ' +
                    _n.street_number + ', ' +
                    _n.apartment_number + ', ' +
                    _n.postal_code + ', ' +
                    _n.bank_name + ', ' +
                    _n.account_number;
                break;
            case 9: // Update arranger commission by admin
                row = this.translate.instant(d) + ' ID: ' + a + '. ' + n + '%';
                break;
            case 10: // Update arranger short description by admin
                row = this.translate.instant(d) + ' ID: ' + a + '. "' + n + '"';
                break;
            case 11: // Update arranger full description by admin
                row = this.translate.instant(d) + ' ID: ' + a + '. "' + n + '"';
                break;
            case 12: // Update arranger short description by user
                row = this.translate.instant(d) + '. "' + n + '"';
                break;
            case 13: // Update arranger full description by user
                row = this.translate.instant(d) + '. "' + n + '"';
                break;
            case 14: // Update arranger details by user
                _n = this.convertToObject(n);
                row = this.translate.instant(d) + '. ' +
                    _n.pesel + ', ' +
                    _n.tax_number + ', ' +
                    _n.country + ', ' +
                    _n.city + ', ' +
                    _n.street + ', ' +
                    _n.street_number + ', ' +
                    _n.apartment_number + ', ' +
                    _n.postal_code + ', ' +
                    _n.bank_name + ', ' +
                    _n.account_number;
                break;
            case 15: // Account created
                row = this.translate.instant(d)
                break;
            default:
                row = '';
                break;
        }

        return row;

    }

    private convertToObject(data: string): any {
        data = JSON.parse(data);
        Object.keys(data).forEach(function (key, index) {
            if (data[key] == null) {
                data[key] = "\'\'";
            }
        });
        return data;
    }

}